module.exports = __webpack_public_path__ + "static/img/icon-thumb.3f98b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/icons/icon-thumb.png
// module id = m4uL
// module chunks = 0